<template>
  <div class="element">
    <span class="name">
      <!-- 闯关中 -->
      <i v-if="(!ele.done&&!ele.lock)" class="icon-lily icon-lily-shouye color1" />
      <!-- 闯关完成 -->
      <i v-else-if="ele.done>0" class="icon-lily icon-lily-duihao color3" />
      <!-- 未解锁 -->
      <i v-else-if="ele.lock" class="icon-lily icon-lily-suoding color1" />
      {{ ele.name.split('#')[0] }}
    </span>
    <span class="attr">
      <span>
        <i :class="attr(ele).icon" class="icon-lily" />
        {{ attr(ele).text }}
      </span>
      <span class="count" v-if="ele.done">
        <i v-if="ele.attrs.continueStudyNum==-1" class="icon-lily icon-lily-24gl-repeatInfinite2" />
        <i v-else class="icon-lily icon-lily-24gl-repeat2">
          <i class="num">{{ ele.snum-ele.rnum }}</i>
        </i>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    ele: [Object],
  },
  methods: {
    attr(ele) {
      // type:  1:音视频 时间  2:题目 数量
      let mediaEleTypes = [
        800, 804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 832, 833,
        834, 823, 826, 801, 830, 829, 827,
      ]
      if (mediaEleTypes.indexOf(ele.type) > -1)
        return {
          type: 1,
          text: `[${this._formatTime(
            ele.attrs.videoDuration || ele.attrs.audioDuration
          )}]`,
          icon: 'icon-lily-shijian',
        }
      else
        return {
          type: 2,
          text: `[${ele.datas ? ele.datas.length : 0}]`,
          icon: 'icon-lily-huodongjilu',
        }
    },
    _formatTime(time) {
      if (!time) return '00:00'
      if (typeof time !== 'number' || time < 0) return time
      time = time / 1000
      let hour = parseInt(time / 3600)
      time = time % 3600
      let minute = parseInt(time / 60)
      let second = parseInt(time % 60)
      if (hour === 0)
        return [minute, second]
          .map(function (n) {
            n = n.toString()
            return n[1] ? n : '0' + n
          })
          .join(':')
      else
        return [hour, minute, second]
          .map(function (n) {
            n = n.toString()
            return n[1] ? n : '0' + n
          })
          .join(':')
    },
  },
}
</script>

<style lang="stylus" scoped>
.element
  display flex
  justify-content space-between
  align-items center
  font-size 18px
  .color3
    color #b6f11f
  .color2
    color #FFFFFF
  .color1
    color #c1d4e5
  .name
    .icon-lily
      font-size 16px
  .attr
    width 120px
    display inline-flex
    justify-content space-between
    align-items center
    .count
      .icon-lily
        font-size 18px
    .icon-lily
      position relative
      font-size 18px
      margin-right 5px
      .num
        position absolute
        font-style normal
        top 0
        left 50%
        transform translateX(-50%) scale(0.8)
        font-size 12px
</style>